(() => {
  const marker = 'data-mh-cart-experience-bound';
  if (document.documentElement.hasAttribute(marker)) return;
  document.documentElement.setAttribute(marker, '');
  let opener = null;

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-mh-cart-open]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const drawer = document.querySelector('.mh-cart-experience cart-drawer-component');
    const dialog = drawer?.querySelector('#cart-drawer-dialog');
    if (!drawer || typeof drawer.open !== 'function' || typeof dialog?.showModal !== 'function') return;
    if ([...document.querySelectorAll('dialog[open]')].some(other => other !== dialog)) return;
    event.preventDefault();
    opener = link;
    drawer.open();
  });

  document.addEventListener('dialog:open', event => {
    if (!(event.target instanceof Element) || !event.target.closest('.mh-cart-experience')) return;
    document.querySelectorAll('[data-mh-cart-open]').forEach(link => link.setAttribute('aria-expanded', 'true'));
  }, true);

  document.addEventListener('dialog:close', event => {
    if (!(event.target instanceof Element) || !event.target.closest('.mh-cart-experience')) return;
    document.querySelectorAll('[data-mh-cart-open]').forEach(link => link.setAttribute('aria-expanded', 'false'));
    if (opener?.isConnected) opener.focus({ preventScroll: true });
    opener = null;
  }, true);
})();
